<template>
    <div class="painel-btns">
        <div v-for="field in fieldsProp" :class="field.class" style="cursor: pointer">
            <a @click="change(field.name)" :class="opcao === field.name ? 'active' : ''">
                <i :class="field.icon"></i>
                {{field.description}}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            fieldsProp: Array,
            tipo: {
                type: String,
                default: 'pendencias'
            }
        },
        data(){
          return {
              opcao: this.tipo ? this.tipo : this.fieldsProp[0].name
          }
        },
        methods: {
            change(valor) {
                this.opcao = valor;
                this.$emit('changeOpcao', this.opcao);
            },
        },
        beforeMount() {
            this.opcao = this.tipo;
        }
    };
</script>